<template lang="html">
  <img :style="style" class="homeResult-image" :src="image.url">
</template>

<script>
export default {
  name: 'HomeResultImage',
  data () {
    return {
      imageWidth: 0,
      imageHeight: 0,
    }
  },
  computed: {
    style () {
      if (this.ratio > 1.5) {
        return {
          transform: `rotate(${Math.random() * 4 - 2}deg)`,
          width: 100 / 2 + '%',
          left: Math.random() * (100 - 100 / 2) + '%',
          top: Math.random() * (100 - 100 / 2) + '%',
        }
      } else {
        return {
          transform: `rotate(${Math.random() * 4 - 2}deg)`,
          height: 100 / 2 + '%',
          left: Math.random() * (100 - 100 / 2) + '%',
          top: Math.random() * (100 - 100 / 2) + '%'
        }
      }
    },
    ratio () {
      return this.imageWidth / this.imageHeight
    }
  },
  props: ['image', 'index', 'scale'],
  created () {
    const self = this
    this.imageLoader = new Image();
    this.imageLoader.addEventListener('load', function () {
      self.imageWidth = this.width;
      self.imageHeight = this.height;
    });
    this.imageLoader.src = this.image.url;
  },
  mounted () {

  }
}
</script>

<style lang="scss" scoped>
@import '../scss/settings';
@import '../scss/mixins';

</style>



// WEBPACK FOOTER //
// src/components/HomeResultImage.vue